/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Settings from '../components/Settings';
import house from '../assets/icons/house-door.svg';

import step1 from '../assets/images/overview/step-1-grafik.svg';
import step2 from '../assets/images/overview/step-2-grafik-01.svg';
import step3 from '../assets/images/overview/step-3-grafik.png';
import step4 from '../assets/images/overview/step-4-grafik.png';

import img1 from '../assets/images/AdobeStock_280820527.jpg';
import img2 from '../assets/images/landingpage/grafik-1.png';
import img3 from '../assets/images/AdobeStock_497172096.jpg';
import img4 from '../assets/images/landingpage/frau-this.png';
import img5 from '../assets/images/AdobeStock_280820527.jpg';
import img6 from '../assets/images/landingpage/Bildmotiv@2x.jpg';
import img7 from '../assets/images/AdobeStock_419808796.jpg';
const LandingPage = () => {
  return (
    <div id='landing-page'>
      <Navbar />
      <div
        id='sub-nav'
        className='container-xxl d-none d-md-block mb-3 mt-4'
        style={{ fontSize: 12 }}>
        <div className='d-flex align-content-center' style={{ gap: '0.5rem' }}>
          <a href='#'>
            {' '}
            <img src={house} alt='' style={{ width: 14 }} />
          </a>
          <span>»</span>
          <a href='#'>Ratgeber</a>
          <span>»</span>
          <a href='#'>Landingpage Beispiel</a>
        </div>
      </div>

      <section className='container-xxl px-0 px-xxl-0' id='hero-landing'>
        <div className='banner'>
          <div>
            <h1 className='mb-2'>Pflegehilfsmittel</h1>
            <h1>
              <span>gratis</span> erhalten
            </h1>
          </div>
          <div>
            <button className='btn-primary'>Jetzt Ihr kostenloses PflegehilfeSet anfordern</button>
          </div>
        </div>
      </section>

      <section className='container px-3 px-lg-3 px-xxl-0 py-5' id='landing-inhalt'>
        <div className='row gx-3 gy-5'>
          <div className='col-12 col-xl-6'>
            <div>
              <h3 className='mb-3'>Alles Wissenswerte zur Pflegebedürftigkeit</h3>
              <p className='mb-3'>
                Pflegebedürftige und pflegende Angehörige sind in der täglichen Arbeit mit dem
                Patienten auf Pflegehilfsmittel angewiesen.
              </p>
              <p className='mb-3'>
                Hat die Person, die zu Hause gepflegt wird, einen anerkannten Pflegegrad, werden die
                Pflegehilfsmittel allerdings zum Teil von der zuständigen Pflegekasse übernommen und
                der Patient damit finanziell entlastet.
              </p>
              <p className='mb-3'>
                § 40 SGB XI (Sozialgesetzbuch Elf) sichert den Rechtsanspruch auf die
                Pflegehilfsmittelpauschale in Höhe von 40 Euro im Monat.
              </p>
              <p className='mb-3'>
                Wir informieren Sie umfassend über Pflegehilfsmittel, Hilfsmittel im Allgemeinen und
                geben Ihnen wertvolle Tipps und Tricks rund um die Pflege zu Hause.
              </p>
              <p className='mb-3'>
                ls Pflegebedürftige gelten im Sinne des Gesetzes Menschen, die aufgrund von
                Erkrankungen oder Verletzungen nicht in der Lage sind, ein eigenständiges und
                selbstbestimmtes Leben zu führen.
              </p>
              <p className='mb-3'>
                A Aufgrund der gesundheitlichen Beeinträchtigung ist eine Pflegebedürftigkeit
                gegeben, wenn sie auf fremde Hilfe angewiesen sind.
              </p>
              <p className='mb-3'>
                Die Anerkennung der Pflegebedürftigkeit erfolgt anhand von körperlichen, kognitiven
                und psychischen Einschränkungen, durch welche die Anforderungen eines normalen
                Alltags nicht mehr allein bewältigt werden können.
              </p>
              <p className='mb-3'>
                Gemäß § 15 Sozialgesetzbuch Elf (SGB XI) muss die Pflegebedürftigkeit dauerhaft,
                mindestens jedoch für sechs Monate vorliegen.
              </p>
            </div>
          </div>
          <div className='col-12 col-xl-6'>
            <div className='py-4 px-2 px-lg-5' style={{ backgroundColor: '#e9faff' }} id='inhalt'>
              <h3 className='mb-3'>Inhalt</h3>
              <div className='d-flex flex-column'>
                <a href='#'>Voraussetzungen und Antragstellung</a>
                <a href='#'>FAQ zur Pflegebedürftigkeit</a>
                <a href='#'>
                  Begutachtung und Antragsfristen für die Anerkennung der Pflegebedürf- tigkeit
                </a>
                <a href='#'>Tipps zur Beantragung der Pflegebedürftigkeit</a>
                <div className='accordion'>
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='heading-a'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapse-a'
                        aria-expanded='true'
                        aria-controls='collapse-a'
                        style={{
                          backgroundColor: '#e9faff',
                          padding: '1rem 0',
                          fontWeight: 'normal',
                          margin: 0,
                          border: 'none',
                          borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                        }}>
                        Grundlagen der Begutachtung
                      </button>
                    </h2>
                    <div
                      id='collapse-a'
                      className='accordion-collapse collapse'
                      aria-labelledby='heading-a'
                      data-bs-parent='#accordionExample'>
                      <div className='accordion-body' style={{ backgroundColor: '#e9faff' }}>
                        <ul>
                          <li>
                            <a href='#heading-a-1'>•   Mobilität gemäß § 14 Abs. 2 Nr. 1 SGB XI</a>
                          </li>
                          <li>
                            <a href='#heading-a-2'>
                              •   Kognitive und kommunikative Fähigkeiten gemäß § 14 Abs. 2 Nr. 2
                              SGB XI
                            </a>
                          </li>
                          <li>
                            <a href='#heading-a-3'>
                              •   Verhaltensweisen und psychische Problemlagen gemäß § 14 Abs. 2 Nr.
                              2 SGB XI
                            </a>
                          </li>
                          <li>
                            <a href='#heading-a-4'>
                              •   Selbstversorgung gemäß § 14 Abs. 2 Nr. 4 SGB XI
                            </a>
                          </li>
                          <li>
                            <a href='#heading-a-5'>
                              •   Erfüllen von krankheits- und therapiebedingten Anforderungen gemäß
                              § 14 Abs. 2 Nr. 5 SGB XI
                            </a>
                          </li>
                          <li>
                            <a href='#heading-a-6'>
                              •   Alltagsleben und soziale Kontakte gemäß § 14 Abs. 2 Nr. 6 SGB XI
                            </a>
                          </li>
                          <li>
                            <a href='#heading-a-7'>
                              •   Beurteilung der Pflegebedürftigkeit anhand der Punktetabelle
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <a href='#'>Pflegebedürftigkeit bei Kindern</a>
                <a href='#'>Anerkennung und Leistungsbescheid der Pflegebedürftigkeit</a>
                <a href='#'>Pflegegeld und Pflegesachleistungen</a>
                <div className='accordion'>
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='heading-b'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapse-b'
                        aria-expanded='true'
                        aria-controls='collapse-b'
                        style={{
                          backgroundColor: '#e9faff',
                          padding: '1rem 0',
                          fontWeight: 'normal',
                          margin: 0,
                          border: 'none',
                          borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                        }}>
                        Plötzliche Pflegebedürftigkeit eines Angehörigen: Das müssen Sie wissen
                      </button>
                    </h2>
                    <div
                      id='collapse-b'
                      className='accordion-collapse collapse'
                      aria-labelledby='heading-b'
                      data-bs-parent='#accordionExample'>
                      <div className='accordion-body' style={{ backgroundColor: '#e9faff' }}>
                        <ul>
                          <li>
                            <a href='#heading-b-1'>
                              •   Arbeitsfreistellung und Pflegeunterstützungsgeld
                            </a>
                          </li>
                          <li>
                            <a href='#heading-b-2'> •   Pflegezeit </a>
                          </li>
                          <li>
                            <a href='#heading-b-3'>•   Familienpflegezeit Abs. 2 Nr. 2 SGB XI</a>
                          </li>
                          <li>
                            <a href='#heading-b-4'>
                              •   Soziale Absicherung während der Pflegezeit
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className='d-flex flex-column flex-lg-row' style={{ gap: '2rem' }}>
              <div className='d-grid align-content-center'>
                <img src={img1} alt='' className='img-1' />
              </div>
              <div className='mt-2'>
                <h3 className='mb-4'>Voraussetzungen und Antragstellung für Pflegebedürftigkeit</h3>
                <p className='mb-4'>
                  Den schriftlichen Antrag auf Pflegebedürftigkeit können die betroffenen Personen
                  selbst stellen, dabei bei Bedarf auch die Hilfe von ihnen nahestehenden Personen
                  in Anspruch nehmen. Ebenso besteht für Familienangehörige, Nachbarn oder Freunde
                  des beeinträchtigten Patienten die Möglichkeit, den Antrag bei der zuständigen
                  Pflegekasse einzureichen, wenn sie über eine entsprechende Vollmacht verfügen. Die
                  wichtigste Voraussetzung für die Antragstellung der Pflegebedürftigkeit und eine
                  mögliche Bewilligung der vollumfänglichen Leistungen ist eine bestehende
                  Familienversicherung über einen Zeitraum von zwei Jahren innerhalb der letzten
                  zehn Jahre. Zudem muss der Betroffene in dieser Zeit in die Pflegekasse Beiträge
                  eingezahlt haben.
                </p>
                <p>
                  Nach Antragstellung auf Pflegebedürftigkeit wird der Medizinische Dienst der
                  Krankenkassen damit beauftragt, die Person zu begutachten, für die der Antrag
                  ausgestellt wurde.
                </p>
              </div>
            </div>
          </div>
          <div className='col-12 pt-5'>
            <div className='row'>
              <div className='col-12 col-lg-8'>
                <h2 className='mb-4'>FAQ zur Pflegebedürftigkeit</h2>
                <div>
                  <div className='accordion'>
                    <div className='accordion-item'>
                      <h2 className='accordion-header' id='headingOne'>
                        <button
                          className='accordion-button'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseOne'
                          aria-expanded='true'
                          aria-controls='collapseOne'>
                          Welche Beeinträchtigungen gelten als Pflegebedürftigkeit?
                        </button>
                      </h2>
                      <div
                        id='collapseOne'
                        className='accordion-collapse collapse show'
                        aria-labelledby='headingOne'
                        data-bs-parent='#accordionExample'>
                        <div className='accordion-body'>
                          <p>
                            Physische oder psychische Einschränkungen sind die Grundvoraussetzung
                            für die Pflegebedürftigkeit. Wenn der Alltag nicht mehr eigenständig zu
                            bewältigen ist, kann ein Antrag gestellt werden. Zu den
                            Beeinträchtigungen gehören:
                          </p>
                          <ul>
                            <li>• Sinnesstörungen</li>
                            <li>• Funktionsstörungen des Bewegungsapparates und der Organe</li>
                            <li>• Lähmungen</li>
                            <li>• Störungen des zentralen Nervensystems</li>
                            <li>• geistige Behinderungen</li>
                            <li>• Psychosen und Neurosen</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className='accordion-item'>
                      <h2 className='accordion-header' id='headingTwo'>
                        <button
                          className='accordion-button collapsed'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseTwo'
                          aria-expanded='false'
                          aria-controls='collapseTwo'>
                          Welche Form ist bei der Antragstellung zu wahren?
                        </button>
                      </h2>
                      <div
                        id='collapseTwo'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingTwo'
                        data-bs-parent='#accordionExample'>
                        <div className='accordion-body'>...</div>
                      </div>
                    </div>
                    <div className='accordion-item'>
                      <h2 className='accordion-header' id='headingThree'>
                        <button
                          className='accordion-button collapsed'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseThree'
                          aria-expanded='false'
                          aria-controls='collapseThree'>
                          Wann erfolgt der Bescheid der Pflegekasse über die Anerkennung der
                          Pflegebedürftigkeit?
                        </button>
                      </h2>
                      <div
                        id='collapseThree'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingThree'
                        data-bs-parent='#accordionExample'>
                        <div className='accordion-body'>...</div>
                      </div>
                    </div>
                    <div className='accordion-item'>
                      <h2 className='accordion-header' id='headingFour'>
                        <button
                          className='accordion-button collapsed'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseFour'
                          aria-expanded='true'
                          aria-controls='collapseFour'>
                          Welche Beeinträchtigungen gelten als Pflegebedürftigkeit?
                        </button>
                      </h2>
                      <div
                        id='collapseFour'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingFour'
                        data-bs-parent='#accordionExample'>
                        <div className='accordion-body'>...</div>
                      </div>
                    </div>
                    <div className='accordion-item'>
                      <h2 className='accordion-header' id='headingFive'>
                        <button
                          className='accordion-button collapsed'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseFive'
                          aria-expanded='false'
                          aria-controls='collapseFive'>
                          Welche Form ist bei der Antragstellung zu wahren?
                        </button>
                      </h2>
                      <div
                        id='collapseFive'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingFive'
                        data-bs-parent='#accordionExample'>
                        <div className='accordion-body'>...</div>
                      </div>
                    </div>
                    <div className='accordion-item'>
                      <h2 className='accordion-header' id='headingSix'>
                        <button
                          className='accordion-button collapsed'
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#collapseSix'
                          aria-expanded='false'
                          aria-controls='collapseSix'>
                          Wann erfolgt der Bescheid der Pflegekasse über die Anerkennung der
                          Pflegebedürftigkeit?
                        </button>
                      </h2>
                      <div
                        id='collapseSix'
                        className='accordion-collapse collapse'
                        aria-labelledby='headingSix'
                        data-bs-parent='#accordionExample'>
                        <div className='accordion-body'>...</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-none d-lg-grid align-content-end col-lg-4'>
                <img src={img2} alt='' className='accordion-img' />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id='pflegen' className='py-5' style={{ position: 'relative' }}>
        <div className='container-xxl px-0'>
          <div className='container-xxl px-3 px-xl-5 px-xxl-0'>
            <div className='my-5 title'>
              <h2>
                Sie pflegen einen Angehörigen zu Hause oder sind selbst pflegebedürftig? Sichern Sie
                sich das PflegehilfeSet im Wert von 40,- Euro?!
              </h2>
              <p className='my-2'>So bekommen Sie Ihr kostenfreies PflegehilfeSet nach Hause.</p>
            </div>
            <div>
              <div className='row gy-5 gx-2 px-3 px-lg-0'>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step1} alt='step1' />
                  </div>
                  <div>
                    <h3>Bestellung</h3>
                    <p>
                      Wählen Sie die benötigten Produkte aus und konfigurieren Sie Ihr individuelles
                      Set im Wert von 40 €. Wir stehen Ihnen auf allen Kommunikationswegen für die
                      Bestellung zur Verfügung.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step2} alt='step2' style={{ height: '100%' }} />
                  </div>
                  <div>
                    <h3>Lieferung</h3>
                    <p>
                      In der Regel erhalten Sie Ihre Bestellung kürzester Zeit direkt nach Hause
                      bzw. zum gewünschten Einsatzort.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step3} alt='step3' />
                  </div>
                  <div>
                    <h3>Beantragung</h3>
                    <p>
                      Schon nach Abschluss Ihrer Bestellung leiten wir für Sie die Beantragung und
                      Abrechnung bei der Pflegekasse ein. Sie brauchen sich um nichts kümmern.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step4} alt='step4' />
                  </div>
                  <div>
                    <h3>Abwicklung</h3>
                    <p>
                      Sie erhalten monatlich Ihr PflegehilfeSet, das Sie bequem an Ihre Bedürfnisse
                      anpassen können. Es gibt keine versteckten Kosten und keine Vertragsbindung -
                      nur volle Flexibilität für Sie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='article-btn'>
              <button className='btn-primary mt-5'>Zum Konfigurator</button>
            </div>
          </div>
        </div>
      </section>

      <section className='container px-3 px-lg-0 px-xxl-0 py-10' id='landing-s3'>
        <div className='row gy-5'>
          <div className='col-12'>
            <div className='row gy-5 d-flex flex-wrap'>
              <div className='col-12 col-lg-7  d-flex flex-column'>
                <h3 className='mb-3'>
                  Begutachtung und Antragsfristen für die Anerkennung der Pflegebedürftigkeit
                </h3>
                <p className='mb-4'>
                  Ist ein gültiger Antrag bei der zuständigen Pflegekasse eingegangen, ist seitens
                  der Sachbearbeiter eine Frist von 25 Arbeitstagen einzuhalten. Liegt der
                  betroffene Patient in einem Krankenhaus, einer Rehabilitationseinrichtung oder ist
                  eine Behandlung zum Zeitpunkt nur in einem Hospiz oder einer
                  ambulanten-palliativen Therapie möglich, muss die Begutachtung innerhalb einer
                  Woche erfolgen. Werden diese Fristen nicht eingehalten, muss die Pflegekasse je
                  angefangene überschrittene Woche 70 Euro an den Antragsteller zahlen.
                </p>
                <p>
                  Ausgenommen ist die Zahlung lediglich, wenn die Pflegekasse die Verzögerung nicht
                  zu verantworten hat oder bei dem Antragsteller zu diesem Zeitpunkt bereits ein
                  anerkannter Pflegegrad, mindestens Pflegegrad 2, besteht oder er sich in einer
                  vollstationären Pflegeeinrichtung befindet.
                </p>
              </div>
              <div className='col-12 col-lg-5   d-flex flex-column'>
                <img src={img3} alt='' height='100%' style={{ objectFit: 'cover' }} />
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className='row'>
              <div className='col-lg-4 d-none d-lg-grid'>
                <img src={img4} alt='' className='img-2' />
              </div>
              <div className='col-12 col-lg-8'>
                <div
                  className='py-4 px-3 px-lg-5'
                  style={{ backgroundColor: '#e9faff' }}
                  id='inhalt-tippz'>
                  <h3 className='mb-3'>Tipps zur Beantragung der Pflegebedürftigkeit</h3>
                  <p>
                    Wenn die Pflegebedürftigkeit plötzlich und unerwartet eintritt, ist schnelles
                    Handeln erforderlich. Oftmals wird bereits nach einem Unfall, einer Operation
                    oder einer schweren Krankheit die Pflegekasse informiert. Auch die schleichende
                    Pflegebedürftigkeit benötigt Vorbereitung. Wir haben Ihnen einige Tipps
                    zusammengefasst, um für den Ernstfall gerüstet zu sein.
                  </p>
                  <ul>
                    <li className='my-3'>
                      <div className='d-flex' style={{ gap: '1rem' }}>
                        <div className='d-flex' style={{ position: 'relative' }}>
                          <span
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              color: 'white',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              backgroundColor: '#96d6e9',
                            }}>
                            <p style={{ color: 'white', fontWeight: 'bold' }}>1</p>
                          </span>
                        </div>
                        <div className='mt-2'>
                          <p>
                            <span className='' style={{ fontWeight: 'bold' }}>
                              Unmittelbares Handeln
                            </span>
                            : Informieren Sie die zuständige Stelle sofort nach der ärztlichen
                            Diagnose. Je früher die Pflegebedürftigkeit anerkannt wird, desto
                            schneller ist Ihr Angehöriger finanziell und durch Sachleistungen
                            abgesichert.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className='my-3'>
                      <div className='d-flex' style={{ gap: '1rem' }}>
                        <div className='d-flex' style={{ position: 'relative' }}>
                          <span
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              color: 'white',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              backgroundColor: '#96d6e9',
                            }}>
                            <p style={{ color: 'white', fontWeight: 'bold' }}>2</p>
                          </span>
                        </div>
                        <div className='mt-2'>
                          <p>
                            <span className='' style={{ fontWeight: 'bold' }}>
                              Hilfestelle aufsuchen:
                            </span>
                            Sozialberater in medizinischen Einrichtungen oder eine unabhängige
                            Pflegeberatung sind in vielen Städten und Gemeinden zu finden. Nehmen
                            Sie diese in Anspruch und informieren Sie sich umfassend über das
                            kommende Prozedere und eine individuelle Fallbetreuung.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className='my-3'>
                      <div className='d-flex' style={{ gap: '1rem' }}>
                        <div className='d-flex' style={{ position: 'relative' }}>
                          <span
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              color: 'white',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              backgroundColor: '#96d6e9',
                            }}>
                            <p style={{ color: 'white', fontWeight: 'bold' }}>3</p>
                          </span>
                        </div>
                        <div className='mt-2'>
                          <p>
                            <span className='' style={{ fontWeight: 'bold' }}>
                              Gute Prävention:
                            </span>
                            Steht der Termin mit dem Gutachter des MDK ins Haus, gilt es sich
                            vorzubereiten. Oftmals wollen die Betroffenen in einem guten Licht
                            dastehen und sind zu stolz, um Hilfe anzunehmen. Der Gutachter muss
                            jedoch erkennen können, dass der Pflegebedürftige Unterstützung
                            benötigt.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className='my-3'>
                      <div className='d-flex' style={{ gap: '1rem' }}>
                        <div className='d-flex' style={{ position: 'relative' }}>
                          <span
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              color: 'white',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              backgroundColor: '#96d6e9',
                            }}>
                            <p style={{ color: 'white', fontWeight: 'bold' }}>4</p>
                          </span>
                        </div>
                        <div className='mt-2'>
                          <p>
                            <span className='' style={{ fontWeight: 'bold' }}>
                              Suche nach einem Pflegedienst:
                            </span>
                            Kümmern Sie sich frühzeitig um einen Pflegedienst, wenn eine Betreuung
                            absehbar ist. So haben Sie ausreichend Zeit, um persönliche Bedürfnisse
                            und den individuellen Pflegebedarf abzuklären.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className='my-3'>
                      <div className='d-flex' style={{ gap: '1rem' }}>
                        <div className='d-flex' style={{ position: 'relative' }}>
                          <span
                            className='d-flex justify-content-center align-items-center'
                            style={{
                              color: 'white',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              backgroundColor: '#96d6e9',
                            }}>
                            <p style={{ color: 'white', fontWeight: 'bold' }}>5</p>
                          </span>
                        </div>
                        <div className='mt-2'>
                          <p>
                            <span className='' style={{ fontWeight: 'bold' }}>
                              Selbstfürsorge für pflegende Angehörige:
                            </span>
                            Kann noch kein Pflegedienst die Arbeit aufnehmen und der Betroffene muss
                            von der Familie gepflegt werden, muss sichergestellt werden, dass die
                            Angehörigen ebenfalls Unterstützung bekommen. Durch diverse
                            Pflegezeit-Modelle, Reha-Kuren oder auch die finanzielle Absicherung
                            wird eine bessere Vereinbarkeit erreicht. Ist keine Heilung in Sicht,
                            kann auch über eine Palliativpflege nachgedacht werden.
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12'>
            <h3 className='mb-4'>Grundlagen der Begutachtung</h3>
            <div className='row' style={{ position: 'relative' }}>
              <div className='col-12 col-lg-6'>
                <p className='mb-3 mb-xxl-4'>
                  In Folge der Antragstellung auf Pflegebedürftigkeit wird von der Pflegekasse der
                  Medizinische Dienst der Krankenkassen mit einem Gutachter beauftragt, den
                  Betroffenen in Augenschein zu nehmen und ihn hinsichtlich gesetzlich
                  vorgeschriebener Kriterien zu beurteilen. Anhand eines Punktesystems wird die
                  Pflegebedürftigkeit festgestellt und die Unterteilung in die entsprechenden
                  Pflegegrade vorgenommen.
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Hinweis <br />
                  Alle Informationen auf dieser sind ohne Gewähr, da sie gesetzlichen Änderungen
                  unterliegen. Hier finden Sie die aktuellsten Gesetze und Informationen zum Thema
                  Pflege beim Bundesministerium für Gesundheit.
                </p>
                <h6 className='mb-2 mb-xxl-3' style={{ fontWeight: 'bold' }} id='heading-a-1'>
                  Mobilität gemäß § 14 Abs. 2 Nr. 1 SGB XI
                </h6>
                <p className='mb-3 mb-xxl-4'>
                  In diesem Bereich werden lediglich körperliche Befähigungen betrachtet. Für eine
                  Bewilligung der Pflegebedürftigkeit geht es ausnahmslos darum, in welchem Maß der
                  Patient in der Lage ist, eigenständig bestimmte Bewegungsabläufe selbstständig
                  vorzunehmen und wobei er Hilfe benötigt.
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Treppen steigen Bewegung in der eigenen Wohnung Umsetzen auf verschiedene
                  Sitzgelegenheiten Beibehalten einer stabilen und sicheren Sitzposition Wechsel von
                  Liegepositionen im Bett.
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Die vorhandene Körperkraft, das Gefühl für Balance und Koordination fließen ebenso
                  in die Begutachtung zur Pflegebedürftigkeit ein.
                </p>
                <h6 className='mb-3' style={{ fontWeight: 'bold' }} id='heading-a-2'>
                  Kognitive und kommunikative Fähigkeiten gemäß § 14 Abs. 2 Nr. 2 SGB XI
                </h6>
                <p className='mb-3 mb-xxl-4'>
                  Die wichtigen Aspekte der Wahrnehmung stehen bei diesem Bereich im Mittelpunkt.
                  Hierbei geht es nicht um motorische Fähigkeiten. Der Gutachter prüft den
                  Betroffenen hinsichtlich Erkennen, Entscheiden und Steuerung von kommunikativen
                  Aktivitäten. Da Pflegebedürftigkeit nicht auf einen Altersbereich begrenzt wird,
                  ist es dabei auch unerheblich, ob die Fähigkeiten jemals erlernt wurden oder
                  aufgrund der gesundheitlichen Beeinträchtigungen verloren gingen.
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Erkennen von Menschen aus dem privaten Umfeld Räumliches und zeitliches
                  Verständnis Erinnerungen an wichtige Ereignisse wie Termine oder vorangegangene
                  Reminiszenzen Eigenständige Steuerung von Alltagshandlungen Treffen von
                  Alltagsentscheidungen Verständnis für Informationen und Sachverhalte Risiko- und
                  Gefahrenerkennung Elementare Bedürfnisse ausdrücken Aufforderungen verstehen und
                  umsetzen Gesprächsbeteiligung.
                </p>
                <h6 className='mb-3' style={{ fontWeight: 'bold' }} id='heading-a-3'>
                  Verhaltensweisen und psychische Problemlagen gemäß § 14 Abs. 2 Nr. 2 SGB XI
                </h6>
                <p className='mb-3 mb-xxl-4'>
                  Auffällige Verhaltensweisen oder psychische Beeinträchtigungen, die in Folge eines
                  Unfalls oder einer Erkrankung auftreten, werden in diesem Bereich in Augenschein
                  genommen. Dabei ist hier besonders die Frage zu klären, in wieweit der
                  Antragsteller sein eigenes Verhalten ohne fremde Hilfe steuern und kontrollieren
                  kann. Auch ist die Prüfung vorzunehmen, in welchem Maß sich der Versicherte an
                  Aufforderungen, ein bestimmtes Verhalten abzustellen, bereits nach kurzer Zeit
                  nicht mehr erinnern kann oder ob er es von Beginn an nicht verstanden hat.{' '}
                </p>
                <p className='mb-3 mb-xxl-4'>
                  {' '}
                  Motorische Auffälligkeiten Unruhe in der Nacht Aggressionen gegenüber sich selbst,
                  Gegenständen und anderen Personen Verbale Aggression Pflegerelevante
                  Auffälligkeiten wie Weigerung oder Beschimpfungen Wahnvorstellung und Ängste
                  Asoziale Verhaltensweisen Depressive Stimmungslage mit allen auftretenden Formen
                  Selbstversorgung gemäß § 14 Abs.2 Nr.4 SGB XI
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Hierbei werden der Antrieb und die Fähigkeiten des Betroffenen in Bezug auf
                  Versorgung und Hygiene begutachtet. Besonders hervorzuheben sind die
                  überlebenswichtigen Kriterien wie Nahrungsaufnahme und Ausscheidungen.{' '}
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Eigenständiges An- und Auskleiden Waschen, Duschen und Hygiene des Oberkörpers,
                  Intimbereiches und Kopfes Selbstständige Zubereitung der Nahrung, Eingießen von
                  Getränken Nahrungs- und Flüssigkeitsaufnahme Nahrungsaufnahme über eine Sonde
                  Benutzung von Toilette oder Toilettenstuhl Umgang mit Harn- und Stuhlinkontinenz,
                  Dauerkatheter, Stoma und Urostoma Problemerkennung bei der Nahrungsaufnahme von
                  Kindern mit einem außergewöhnlichen Pflegebedarf unter 18 Monaten.
                </p>
              </div>
              <div className='col-12 col-lg-6'>
                <h6 className='mb-2 mb-xxl-3' id='heading-a-4'>
                  Selbstversorgung gemäß § 14 Abs. 2 Nr. 4 SGB XI
                </h6>
                <div>
                  <p>
                    Hierbei werden der Antrieb und die Fähigkeiten des Betroffenen in Bezug auf
                    Versorgung und Hygiene begutachtet. Besonders hervorzuheben sind die
                    überlebenswichtigen Kriterien wie Nahrungsaufnahme und Ausscheidungen.{' '}
                  </p>
                  <ul className='mb-3 mb-xxl-4'>
                    <li>
                      <p>
                        • Eigenständiges An- und Auskleiden • Waschen, Duschen und Hygiene des
                        Oberkörpers, Intimbereiches und Kopfes
                      </p>
                    </li>
                    <li>
                      <p>• Selbstständige Zubereitung der Nahrung, Eingießen von Getränken </p>
                    </li>
                    <li>
                      <p>• Nahrungs- und Flüssigkeitsaufnahme</p>
                    </li>
                    <li>
                      <p> • Nahrungsaufnahme über eine Sonde</p>
                    </li>
                    <li>
                      <p>• Benutzung von Toilette oder Toilettenstuhl </p>
                    </li>
                    <li>
                      <p>
                        • Umgang mit Harn- und Stuhlinkontinenz, Dauerkatheter, Stoma und Urostoma{' '}
                      </p>
                    </li>
                    <li>
                      <p>
                        • Problemerkennung bei der Nahrungsaufnahme von Kindern mit einem
                        außergewöhnlichen Pflegebedarf unter 18 Monaten
                      </p>
                    </li>
                  </ul>
                </div>
                <h6 className='mb-2 mb-xxl-3' id='heading-a-5'>
                  Selbstversorgung gemäß § 14 Abs. 2 Nr. 4 SGB XI
                </h6>
                <p className='mb-3 mb-xxl-4'>
                  Bei einem vorliegenden Krankheitsbild ist hier der Umgang mit den
                  Therapiemaßnahmen zu betrachten. In welchem Maß kann der Versicherte die
                  Anforderungen aus eigener Kraft durchführen oder wobei wird Hilfe benötigt. Dabei
                  muss das Krankheitsbild für mindestens sechs Monate Bestand haben.{' '}
                </p>
                <p className='mb-3 mb-xxl-4'>
                  Medikation und Injektion nach Vorschrift einnehmen Messen und Interpretieren von
                  Fieberzuständen Verbandswechsel und Wundversorgung Umgang mit intravenösen
                  Zugängen und körpernahen Hilfsmitteln Umgang mit Einmalkatheter und abführenden
                  Methoden Arztbesuche und therapeutische Maßnahmen wahrnehmen, auch in häuslicher
                  Umgebung – innerhalb von drei Stunden oder länger ausgedehnte Maßnahmen Einhalten
                  von Diätvorschriften Frühförderung bei Kindern.
                </p>
                <div>
                  <h6 className='mb-2 mb-xxl-3' id='heading-a-6'>
                    Selbstversorgung gemäß § 14 Abs. 2 Nr. 4 SGB XI
                  </h6>
                  <p>
                    Die Beobachtung eines geregelten Alltags und der damit verbundenen Hürden werden
                    im letzten Bereich in die Begutachtung über die Pflegebedürftigkeit eines
                    Patienten einbezogen. Unerheblich ist dabei, ob die Beeinträchtigungen aufgrund
                    von psychischen oder körperlichen Schäden eintreten.
                  </p>
                  <ul className='mb-3 mb-xxl-4'>
                    <li>
                      <p>• Tagesablauf gestalten und gegebenenfalls Veränderungen anpassen</p>
                    </li>
                    <li>
                      <p>• Regelmäßige Schlaf- und Ruhezeiten</p>
                    </li>
                    <li>
                      <p>• Selbstständiges Beschäftigen</p>
                    </li>
                    <li>
                      <p>• Zukunftsplanungen</p>
                    </li>
                    <li>
                      <p>• Regelmäßiger Kontakt mit Personen aus dem direkten Umfeld</p>
                    </li>
                    <li>
                      <p>• Soziale Kontakte außerhalb des direkten Umfeldes pflegen</p>
                    </li>
                  </ul>
                  <p className='mb-3 mb-xxl-4'>
                    Zusätzlich werden vom Medizinischen Dienst der Krankenkassen noch Beobachtungen
                    zur eigenen Haushaltsführung und außerhäuslichen Aktivitäten herangezogen, die
                    allerdings keinen direkten Einfluss auf die Bewilligung der Pflegebedürftigkeit
                    haben. Je nachdem, welcher Pflegegrad anschließend anerkannt wird, beurteilt der
                    MDK zusätzlich den Pflegebedarf, falls zusätzliche Maßnahmen notwendig werden,
                    dabei wird besonders berücksichtigt, ob ein vollständiger Verlust der Arm- und
                    Beintätigkeiten vorliegt.
                  </p>
                </div>
                <div>
                  <h6 className='mb-2 mb-xxl-3' id='heading-a-7'>
                    Beurteilung der Pflegebedürftigkeit anhand der Punktetabelle
                  </h6>
                  <ul className='mb-3 mb-xxl-4'>
                    <li>
                      <p>
                        • Pflegegrad 1: 12,5 bis unter 27 Punkte (geringe Beeinträchtigung der
                        Selbstständigkeit){' '}
                      </p>
                    </li>
                    <li>
                      <p>
                        • Pflegegrad 2: 27 bis unter 47,5 Punkte (erhebliche Beeinträchtigung der
                        Selbstständigkeit)
                      </p>
                    </li>
                    <li>
                      <p>
                        • Pflegegrad 3: 47,5 bis unter 70 Punkte (schwere Beeinträchtigung der
                        Selbstständigkeit)
                      </p>
                    </li>
                    <li>
                      <p>
                        • Pflegegrad 4: 70 bis unter 90 Punkte (schwerste Beeinträchtigung der
                        Selbstständigkeit){' '}
                      </p>
                    </li>
                    <li>
                      <p>
                        • Pflegegrad 5: 90 bis 100 Punkte (schwerste Beeinträchtigung der
                        Selbstständigkeit mit besonderen Anforderungen für die pflegerische
                        Versorgung)
                      </p>
                    </li>
                  </ul>
                </div>
                <div className=' btn-container'>
                  <button className='btn-primary'>Zum Konfigurator</button>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12'>
            <img src={img5} alt='' width='100%' height='400px' style={{ objectFit: 'cover' }} />
          </div>
          <div className='col-12 py-5'>
            <div className='row d-flex flex-wrap'>
              <div className='col-lg-4 d-none d-lg-flex flex-column'>
                <div className='d-flex flex-column justify-content-between align-content-between'>
                  <img
                    src={img6}
                    alt=''
                    style={{ objectFit: 'cover' }}
                    height='861px'
                    width='100%'
                  />
                </div>
              </div>
              <div className='col-12 col-lg-8 d-flex flex-column justify-content-between align-content-between'>
                <div>
                  <h2 className='mb-2'>Pflegebedürftigkeit bei Kindern</h2>
                  <p>
                    Auch in diesem Fall wird die Begutachtung durch den MDK durchgeführt, hierfür
                    sind speziell geschulte Fachkräfte im Einsatz, die über Qualifikationen als
                    Kinderkrankenpfleger verfügen. Die Ermittlung der Pflegegrade erfolgt dabei
                    anhand der für das entsprechende Alter typischen Fähigkeiten. Besonders bei der
                    Feststellung der Pflegebedürftigkeit bei Kindern unter 18 Monaten werden
                    altersunabhängige Gesichtspunkte wie Verhaltensweisen und psychische
                    Problemlagen, Schwierigkeiten bei der Nahrungsaufnahme oder der Umgang mit
                    krankheitsbedingten Maßnahmen in die Begutachtung einbezogen.
                  </p>
                </div>
                <div>
                  <h2 className='mb-2'>
                    Anerkennung und Leistungsbescheid der Pflegebedürftigkeit
                  </h2>
                  <p>
                    Anhand der Beurteilung der sechs Bereiche wird im Anschluss durch die
                    Pflegekasse der Pflegebedarf ermittelt. Die Unterteilung erfolgt in fünf
                    Pflegegraden. Die Leistungen sind daher sehr verschieden und werden in
                    Pflegegeld und Pflegesachleistung sowie Zahlung für teil- und vollstationäre
                    Pflege unterteilt. Der Gesetzgeber möchte dabei die häusliche Pflege und die
                    Selbstständigkeit der Betroffenen nach dem Prinzip „ambulant vor stationär“ so
                    lange wie möglich gesondert unterstützen.
                  </p>
                  <div className='table-responsive mt-4'>
                    <table className='table ' style={{ borderBottom: '1px solid #ddd' }}>
                      <thead>
                        <tr>
                          <th scope='col'>Pflegegrad</th>
                          <th scope='col'>Pflegegeld</th>
                          <th scope='col'>Pflegesachleistung</th>
                          <th scope='col'>Teilstationäre Pflege</th>
                          <th scope='col'>Vollstationäre Pflege</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope='row'>1</th>
                          <td>125 Euro</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <th scope='row'>2</th>
                          <td>316 Euro</td>
                          <td>689 Euro</td>
                          <td>689 Euro</td>
                          <td>770 Euro</td>
                        </tr>
                        <tr>
                          <th scope='row'>3</th>
                          <td>545 Euro</td>
                          <td>1298 Euro</td>
                          <td>1298 Euro</td>
                          <td>1262 Euro</td>
                        </tr>
                        <tr>
                          <th scope='row'>4</th>
                          <td>728 Euro</td>
                          <td>1612 Euro</td>
                          <td>1612 Euro</td>
                          <td>1775 Euro</td>
                        </tr>
                        <tr>
                          <th scope='row'>5</th>
                          <td>901 Euro</td>
                          <td>1995 Euro</td>
                          <td>1995 Euro</td>
                          <td>2005 Euro</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  Der Leistungsbescheid soll den Betroffenen so transparent wie nur möglich über die
                  Pflegebedürftigkeit unterrichten. Bei einer Ablehnung ist ein Widerspruch ratsam,
                  bei Bedarf auch bis zu einer gerichtlichen Instanz.
                </div>
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className='row gy-5 d-flex flex-wrap'>
              <div className='col-12 col-lg-7  d-flex flex-column'>
                <h3 className='mb-3'>Pflegegeld und Pflegesachleistungen</h3>
                <p className='mb-3 mb-xll-4'>
                  Eine monetäre Auszahlung in Form eines Pflegegeldes steht jedem Pflegebedürftigen
                  zu. Wie es eingesetzt wird, entscheidet der Betroffene eigenmächtig.
                  Erfahrungsgemäß wird es den pflegenden Angehörigen als Aufwandsentschädigung zur
                  Verfügung gestellt.
                </p>
                <p className='mb-3 mb-xll-4'>
                  Pflegesachleistungen hingegen werden nicht an den Patienten ausgezahlt. Die
                  Beträge sollen die Kosten decken, die bei der häuslichen Pflege durch die
                  Unterstützung eines ambulanten Pflegedienstes entstehen. Der Pflegedienst rechnet
                  daher auch direkt mit der Pflegekasse ab. Wird das Budget überschritten, muss der
                  Leistungsempfänger die Differenz selbst tragen. Die ambulante Pflege kann sich
                  dabei unterschiedlich gestalten. Sie kann am Tag unterstützend eingesetzt werden,
                  aber auch als stationäre Nachtpflege in einer speziellen Einrichtung. Hinzu kommen
                  Kosten für eine Verhinderungspflege, falls der pflegende Angehörige durch Arbeit
                  oder Urlaub nicht verfügbar ist.
                </p>
                <p>
                  Anspruchsberechtigt für Pflegesachleistungen sind pflegebedürftige Patienten ab
                  dem Pflegegrad 2. Zu den Pflegesachleistungen zählen unterstützende Maßnahmen in
                  der ambulanten Pflege, der Haushaltsführung sowie pflegerische Hilfen bei Hygiene,
                  Körperpflege, Ernährung und Bewegung. Zusätzlich können bei Bewilligung der
                  Pflegebedürftigkeit unabhängig vom Pflegegrad jederzeit nach § 40 Abs. 2 SGB XI
                  Pflegehilfsmittel für den Verbrauch beantragt werden. Ein monatliches Budget von
                  60 Euro steht jedem Betroffenen für Pflegehilfsmittel zu Verfügung. Dazu zählen:
                </p>
                <ul>
                  <li> • Desinfektionsmittel für Hände und Flächen </li>
                  <li> • Einmalhandschuhe </li>
                  <li> • Bettschutzeinlagen </li>
                  <li>• Schutzschürzen </li>
                  <li> • Mundschutz </li>
                </ul>
              </div>
              <div className='col-12 col-lg-5   d-flex flex-column'>
                <img src={img7} alt='' height='100%' style={{ objectFit: 'cover' }} />
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className='row'>
              <div className='col-12 col-lg-6'>
                <h3 className='mb-4'>
                  Plötzliche Pflegebedürftigkeit eines Angehörigen: Das müssen Sie wissen
                </h3>
              </div>
            </div>
            <div className='row'>
              <div className='col-12 col-lg-6'>
                <div>
                  <p className='mb-3 mb-xxl-4'>
                    Ein Unfall oder eine Krankheit kann schnell zu einer Pflegebedürftigkeit von
                    Eltern, Großeltern oder sogar Kindern führen. In diesem Moment kann das eigene
                    Leben nicht mehr so weitergeführt werden wie bisher, Sie müssen sich neu
                    organisieren und im schlimmsten Fall auch das Leben Ihres pflegebedürftigen
                    Angehörigen stemmen. Vor allem Menschen, die mitten im Berufsleben stehen,
                    trifft die plötzliche Pflegebedürftigkeit eines nahen Verwandten besonders hart.
                  </p>
                  <p className='mb-3 mb-xxl-4'>
                    Nicht nur dem Betroffenen selbst steht in Bezug auf die Pflegebedürftigkeit ein
                    Antragsmarathon bevor, auch Sie als pflegender Angehöriger haben Rechte, die Sie
                    in Anspruch nehmen können.
                  </p>
                </div>
                <div>
                  <h6 id='heading-b-1' className='mb-2 mb-xxl-3' style={{ fontWeight: 'bold' }}>
                    Arbeitsfreistellung und Pflegeunterstützungsgeld
                  </h6>
                  <p className='mb-3 mb-xxl-4'>
                    Ab dem Eintritt der besonderen Pflegesituation steht Ihnen kurzzeitig das Recht
                    auf eine Freistellung in Ihrem Beruf zu. Für zehn Tage können Sie diesen
                    Sonderurlaub beantragen und gleichzeitig das Pflegeunterstützungsgeld, dass
                    Ihnen einen finanziellen Ausgleich verschafft. In dieser Zeit können Sie die
                    Erstversorgung übernehmen und sich um die Antragsabwicklung zur
                    Pflegebedürftigkeit kümmern.
                  </p>
                </div>
                <div>
                  <h6 id='heading-b-2' className='mb-3' style={{ fontWeight: 'bold' }}>
                    Pflegezeit
                  </h6>
                  <p className='mb-3 mb-xxl-4'>
                    Analog zur Elternzeit haben Sie einen gesetzlichen Sonderkündigungsschutz, wenn
                    Sie sich die ersten sechs Monate um Ihren Angehörigen kümmern. Ihnen steht es
                    nach dem Pflegezeitgesetz zu, dass Sie in dieser Zeit Ihren Beruf nicht ausüben
                    müssen. Einen finanziellen Ausgleich erhalten Sie unter Umständen über das
                    Pflegegeld, dass Ihnen der Pflegebedürftige auszahlt.
                  </p>
                </div>
              </div>
              <div className='col-12 col-lg-6'>
                <h6 id='heading-b-3' className='mb-2 mb-xxl-3'>
                  Familienpflegezeit
                </h6>
                <div>
                  <p>
                    Dauert die Pflegebedürftigkeit länger als sechs Monate an, haben Sie die
                    Möglichkeit, die Familienpflegezeit für 24 Monate in Anspruch zu nehmen. Einzige
                    Voraussetzung hierbei ist, dass Sie bei Ihrem Arbeitgeber mit mindestens 15
                    Wochenstunden angestellt sind. Während der Familienpflegezeit ruht Ihr
                    Arbeitsverhältnis bis auf die 15 Wochenstunden. Den Verdienstausfall können Sie
                    entweder über das Pflegegeld Ihres Angehörigen oder über ein zinsloses Darlehen
                    vom Bundesamt für Familie abfedern. Sie können die Familienpflegezeit bei einer
                    Pflegebedürftigkeit bei folgendem Personenkreis in Anspruch nehmen:
                  </p>
                  <ul className='mb-3 mb-xxl-4'>
                    <li>
                      <p>• Eltern, Schwieger- und Stiefeltern</p>
                    </li>
                    <li>
                      <p>• Großeltern</p>
                    </li>
                    <li>
                      <p>• Ehegatten, Lebenspartner, Partner einer eheähnlichen Gemeinschaft</p>
                    </li>
                    <li>
                      <p>
                        • Geschwister, Schwager oder Schwägerin, Lebenspartner der Geschwister,
                        Geschwister der
                      </p>
                    </li>
                    <li>
                      <p> • Lebenspartner</p>
                    </li>
                    <li>
                      <p>
                        • leibliche Kinder, Adoptiv- und Pflegekinder, Kinder des Ehegatten oder
                        Lebenspartners{' '}
                      </p>
                    </li>
                    <li>
                      <p>• Schwiegerkinder </p>
                    </li>
                    <li>
                      <p>• Enkelkinder</p>
                    </li>
                  </ul>
                </div>
                <h6 id='heading-b-4' className='mb-2 mb-xxl-3'>
                  Soziale Absicherung während der Pflegezeit
                </h6>
                <p className='mb-3 mb-xxl-4'>
                  Wenn ein naher Angehöriger in eine Pflegebedürftigkeit fällt, zahlt die
                  Pflegekasse Ihre vollen Beiträge zur Rentenversicherung sowie Ihre Beiträge zur
                  Pflege- und Krankenversicherung, wenn Sie sich mindestens zehn Stunden pro Woche
                  der Pflege widmen und dadurch eine Auszeit im Beruf nehmen.
                </p>
              </div>
              <div className='row justify-content-center pt-5' style={{ textAlign: 'center' }}>
                <div className='col-12 col-lg-8'>
                  <h6>Hinweis</h6>
                  <p>
                    Alle Informationen auf dieser Seite sind ohne Gewähr, da sie gesetzlichen
                    Änderungen unterliegen.
                  </p>
                  <p>
                    Die aktuellsten Gesetze und Informationen zum Thema Pflege beim
                    Bundesministerium für Gesundheit finden Sie
                    <a href='#'>
                      <u>hier »</u>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id='newsletter'>
        <div className='title px-2'>
          <h2 className=''>Newsletter</h2>
          <p>Abonnieren Sie den kostenlosten Newsletter!</p>
        </div>
        <div className='newsletter-input'>
          <input type='email' name='email' placeholder='E-Mail-Adresse eingeben…' id='email' />
          <button className=''>Abonnieren</button>
        </div>
      </section>

      <Footer />

      <Settings />
    </div>
  );
};

export default LandingPage;
